<template>
	<div class="head">
		<div class="headInner">
			<div class="headTop">
				<div class="headTopLeft" v-if="isLogin == false">
					<div class="setTextPadding">{{$t('components.head2.welcome_to_roke')}}</div>
					<router-link to="/login">
						<div class="linkText">{{$t('components.head2.login_prompt')}}</div>
					</router-link>
					<div class="line1"></div>
					<router-link to="/register">
						<div class="linkText">{{$t('components.head2.free_register')}}</div>
					</router-link>
				</div>
				<div class="headTopLeft" v-else>
					<div class="setTextPadding">{{$t('components.head2.welcome_name', { name: memberInfo.contact_name || '' })}}</div>
					<div class="setTextPadding">{{memberInfo.enterprise}}</div>
						<div class="linkText bannerBtnText" @click="LoginOut()">{{$t('components.head2.logout')}}</div>
				</div>
				<div class="headTopRight">
					<div class="headTopRightLi" v-if="isLogin&&currentLanguage==='zh-CN'">
						<div class="headTopLiInner" @click="infoShow">
							<img  src="../assets/images/message_small.png" class="headLiIcon"/>
							<!-- <img src="../assets/images/message_small_black.png" class="headLiIcon"/> -->
							{{$t('components.head2.message')}}
							<img  src="../assets/images/down_small.png" class="heatTran"/>
						</div>
						<div class="infoArea" @click="hideInfo" v-if="isShowInfo">
							<div class="infoAreaTitle">{{$t('components.head2.latest_messages')}}</div>
							<div class="emptyArea"  style="display:none">
								<img src="../assets/images/message_gray.png"/>
								<div class="emptyText">{{$t('components.head2.no_messages')}}</div>
							</div>
							<div class="infos">
								<div class="infoLi" v-for="(item,index) in messageInfo" :key="item.id">
									<div class="infoTitle">
										<div>{{item.title}}</div>
										<div class="time">{{item.gmt_create}}</div>
									</div>
									<div class="infoText">{{item.content}}</div>
								</div>
							</div>
							<div class="lookMore"><router-link :to="{path:'/my',query:{type:'MESSAGE'}}" style="color: #333333;">{{$t('components.head2.view_all')}}</router-link></div>
						</div>
					</div>
					<div class="headTopRightLi" v-if="currentLanguage==='zh-CN'">
						<div class="headTopLiInner" :class="{topBg: isShowOrder}" @click="showOrder">
							<img src="../assets/images/order_small_black.png" class="headLiIcon" v-if="isShowOrder"/>
						<img src="../assets/images/order_small.png" class="headLiIcon"  v-else/>
						{{$t('components.head2.my_orders')}}
							<img src="../assets/images/down_small_black.png" class="heatTran tranTop" v-if="isShowOrder"/>
							<img src="../assets/images/down_small.png" class="heatTran " v-else/>
						</div>
						<div class="guideArea orderArea" @click="hideOrder"  v-if="isShowOrder">
							<ul v-if="isLogin">
								<!-- {path:'/detail',query:{id:item.id}} -->
								<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER',state:0}}" style="color: #333333;">{{$t('components.head2.all_orders')}}</router-link></li>
								<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER',state:1}}" style="color: #333333;">{{$t('components.head2.pending_payment')}}</router-link></li>
								<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER',state:2}}"  style="color: #333333;">{{$t('components.head2.pending_shipment')}}</router-link></li>
								<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER',state:3}}" style="color: #333333;">{{$t('components.head2.pending_receipt')}}</router-link></li>
								<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER',state:4}}" style="color: #333333;">{{$t('components.head2.completed')}}</router-link></li>
								<li class="listText"><router-link :to="{path:'/my',query:{type:'AFTERSALE'}}" style="color: #333333;">{{$t('components.head2.aftersale')}}</router-link></li>
							</ul>
							<ul v-else>
								<li class="listText"><router-link to="/" style="color: #333333;">{{$t('components.head2.all_orders')}}</router-link></li>
								<li class="listText"><router-link to="/" style="color: #333333;">{{$t('components.head2.pending_payment')}}</router-link></li>
								<li class="listText"><router-link to="/" style="color: #333333;">{{$t('components.head2.pending_shipment')}}</router-link></li>
								<li class="listText"><router-link to="/" style="color: #333333;">{{$t('components.head2.pending_receipt')}}</router-link></li>
								<li class="listText"><router-link to="/" style="color: #333333;">{{$t('components.head2.completed')}}</router-link></li>
								<li class="listText"><router-link to="/" style="color: #333333;">{{$t('components.head2.aftersale')}}</router-link></li>
							</ul>
						</div>
					</div>
					<div class="headTopRightLi"  v-if="isLogin">
						<div class="headTopLiInner" :class="{topBg: isTopPannelshow}" @click="showTopPannle">
							<img src="../assets/images/person_small_black.png" class="headLiIcon" v-if="isTopPannelshow"/>
							<img src="../assets/images/person_small.png" class="headLiIcon"  v-else/>
							{{$t('components.head2.personal_center')}}
							<img src="../assets/images/down_small_black.png" class="heatTran tranTop" v-if="isTopPannelshow"/>
							<img src="../assets/images/down_small.png" class="heatTran " v-else/>
						</div>
						<div class="topPannel" @click="hideTopPannle" v-if="isTopPannelshow">
							<div class="pannelList" v-if="currentLanguage==='zh-CN'">
								<div class="listTitle">{{$t('components.head2.order_center')}}</div>
								<ul class="topPannelUl">
									<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER',state:0}}" style="color: #333333;">{{$t('components.head2.my_orders')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/my',query:{type:'ORDER'}}" style="color: #333333;">{{$t('components.head2.aftersale')}}</router-link></li>
								</ul>
							</div>
							<div class="pannelList" v-if="currentLanguage==='zh-CN'">
								<div class="listTitle">{{$t('components.head2.invoice')}}</div>
								<ul class="topPannelUl">
									<li class="listText"><router-link :to="{path:'/my',query:{type:'INVOICEINFO'}}" style="color: #333333;">{{$t('components.head2.invoice_info')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/my',query:{type:'APPLYINVOICE'}}" style="color: #333333;">{{$t('components.head2.apply_invoice')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/my',query:{type:'INVOICE'}}" style="color: #333333;">{{$t('components.head2.my_invoice')}}</router-link></li>
								</ul>
							</div>
							<div class="pannelList" v-if="currentLanguage==='zh-CN'">
								<div class="listTitle">{{$t('components.head2.records')}}</div>
								<ul class="topPannelUl">
									<li class="listText"><router-link :to="{path:'/my',query:{type:'HISTORY'}}" style="color: #333333;">{{$t('components.head2.browse_history')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/my',query:{type:'COLLECTION'}}" style="color: #333333;">{{$t('components.head2.my_collection')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/my',query:{type:'UNCOMMENT',tabIdx:0}}" style="color: #333333;">{{$t('components.head2.product_review')}}</router-link></li>
								</ul>
							</div>
							<div class="pannelList">
								<div class="listTitle">{{$t('components.head2.settings')}}</div>
								<ul class="topPannelUl">
									<li class="listText"><router-link :to="{path:'/my',query:{type:'MYINFO'}}" style="color: #333333;">{{$t('components.head2.my_info')}}</router-link></li>
									<li class="listText" v-if="currentLanguage==='zh-CN'"><router-link :to="{path:'/my',query:{type:'COMPAYINFO'}}" style="color: #333333;">{{$t('components.head2.company_info')}}</router-link></li>
									<li class="listText" v-if="currentLanguage==='zh-CN'"><router-link :to="{path:'/my',query:{type:'ADDRESSES'}}" style="color: #333333;">{{$t('components.head2.addresses')}}</router-link></li>
								</ul>
							</div>

						</div>
					</div>
					<div class="headTopRightLi">
						<div class="headTopLiInner" :class="{topBg: isShowGuide}" @click="showGuide">
							<img src="../assets/images/guide_small_black.png" class="headLiIcon" v-if="isShowGuide"/>
							<img src="../assets/images/guide_small.png" class="headLiIcon" v-else/>
							{{$t('components.head2.usage_guide')}}
							<img src="../assets/images/down_small_black.png" class="heatTran tranTop" v-if="isShowGuide"/>
							<img src="../assets/images/down_small.png" class="heatTran " v-else/>
						</div>
						<div class="guideArea" @click="hideGuide"  v-if="isShowGuide">
							<ul>
									<li class="listText"><router-link :to="{path:'/guide',query:{type:'ToBuy'}}" style="color: #333333;">{{$t('components.head2.guide_how_to_order')}}</router-link></li>
									<li  class="listText"><router-link :to="{path:'/guide',query:{type:'ToSearchOrder'}}" style="color: #333333;">{{$t('components.head2.guide_view_order_progress')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/guide',query:{type:'ShippingFee'}}" style="color: #333333;">{{$t('components.head2.guide_shipping_fee')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/guide',query:{type:'SalePolicy'}}" style="color: #333333;">{{$t('components.head2.guide_after_sale_policy')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/guide',query:{type:'InvoiceApply'}}" style="color: #333333;">{{$t('components.head2.guide_how_to_apply_invoice')}}</router-link></li>
									<li class="listText"><router-link :to="{path:'/guide',query:{type:'Contact'}}" style="color: #333333;">{{$t('components.head2.guide_contact_us')}}</router-link></li>
							</ul>
						</div>
					</div>
					<div class="headTopRightLi">
						<div class="headTopLiInner" :class="{topBg: isShowLanguage}" @click="showLanguage">
							<img  src="../assets/langIcon/language.png"/>
							<img  src="../assets/langIcon/language_active.png"  v-if="isShowLanguage"/>
							{{$t('components.head2.language')}}
							<img src="../assets/images/down_small_black.png" class="heatTran tranTop" v-if="isShowLanguage"/>
							<img src="../assets/images/down_small.png" class="heatTran " v-else/>
						</div>
						<div class="languageArea"   v-if="isShowLanguage">
							<ul>
								<li class="listText" @click="switchLanguage('zh-CN')">{{$t('components.head2.lang_zh')}}</li>
								<li  class="listText" @click="switchLanguage('en-US')">{{$t('components.head2.lang_en')}}</li>
							</ul>
						</div>
					</div>
					<div class="headTel">18862938532</div>
				</div>
			</div>
		</div>
		<div class="headMiddle">
			<router-link to='/index'>
				<img src="../assets/images/logo.png" class="log" />
			</router-link>
			<div class="line"></div>
						<div class="headTitle" v-html="$t('components.head2.platform_intro')"></div>
			<div class="searchArea">
				<div class="searchAreaTop">
					<div class="searchLeft" @click.self="showPannel">
						<span>{{$t('components.head2.cate_name')}}</span>
						<img  src="../assets/images/down_small_black.png" class="downBlack"/>
						<div class="pannel" @click="hidePannel" v-if="isPannelShow == true">
							<div class="li" v-for="(item,index) in hotcategoryList" :key="item.id"  @click="selectCateInfo(item.id,item.name)" >{{item.name}}</div>		 
						</div>
					</div>
					<div class="searchMiddle">
								<img src="../assets/images/search_gray.png" class="searchGray" />
								<input type="text" :placeholder="$t('components.head2.search_placeholder')" class="searchInput" v-model="keywords" @keyup.enter="search"/>
					</div>
								<div class="searchBtn" @click="search">{{$t('components.head2.search')}}</div>
				</div>
				<ul class="headUl">
					
					<li v-for="(item,index) in hotKeyInfo" :key="item.id">
					<router-link :to="{path:'/category',query:{keywords:item.keywords}}">
						{{item.keywords}}
					</router-link>
					</li>
					
				</ul>
			</div>
			<router-link to="car">
				<div class="headCar">
					<img src="../assets/images/small_car.png" class="carSmall" />
								<span>{{$t('components.head2.shopping_cart')}}</span>
					<div class="headNum">{{shoppingcount}}</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLogin: false,
				hotKeyInfo: {},
				count: 6,
				userName:"",
				memberInfo:{},
				shoppingcount:0,
				keywords:'',
				isPannelShow: false,
				isTopPannelshow: false,
				isShowGuide: false,
				isShowOrder: false,
				isShowInfo: false,
				messageInfo:[],
				hotcategoryList: [],
				selectCate:0,
				isShowLanguage: false,
				currentLanguage:localStorage.getItem('locale-lang')||'zh-CN',
			}
		},
		created() {
			this.keywords=this.$route.query.keywords;
			if(this.$route.query.selectText!=undefined)
			{
				this.cateName=this.$route.query.selectText;
				this.selectCate=this.$route.query.id;
			}
			this.checkLogin();
			this.getHotKeyInfo();
			this.getHotCategoryInfo();
		},
		methods: {
		
			selectCateInfo(id,name)
			{
				this.selectCate=id;
				this.cateName=name;
				this.hidePannel();
				//跳转分类页面
				if(id>0)
				{
					this.$router.push({ path:'/category' , query:{id:id,keywords:this.keywords}});
				}
				else
				{
					this.$router.push({ path:'/category' , query:{keywords:this.keywords}});
				}
			},
			getHotKeyInfo() {
				this.$scUtil.axiosPost(this, 'HotKeyApi/GetHotKeyList', {
					count: this.count
				}, res => {
					if (res.code == 100) {
						this.hotKeyInfo = res.data;
						//console.log(this.hotKeyInfo);
					}

				});
			},
			getHotCategoryInfo() {
				this.$scUtil.axiosPost(this, 'CategoryApi/GetHotCategory', {
					count: 5
				}, res => {
					if (res.code == 100) {
						this.hotcategoryList = res.data;
						//console.log(this.hotcategoryList);
					}
			
				});
			},
			checkLogin()
			{
				this.$scUtil.checkLogin(this, res => {
					if (res) {
						// 已登录：设置状态并获取用户相关信息
						this.isLogin = true;
						this.userName = localStorage.getItem('username');
						this.GetMemberInfo();
						this.GetCartInfo();
						this.GetMessageInfo();
					} else {
						// 未登录：不要主动跳转到登录页，保留在当前页面并显示未登录状态
						// 之前此处会强制跳转到登录页，导致首页启动后直接跳转。
						this.isLogin = false;
					}
				});
			},
			LoginOut()
			{
				localStorage.setItem('username',"");
				localStorage.setItem('logintoken',"");
				this.$router.push({name:'LoginVue'})
			},
			GetMemberInfo()
			{
				this.$scUtil.axiosPost(this, 'MemberApi/GetMemberInvoice', {
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.memberInfo = res.data;
						//console.log(JSON.stringify(this.memberInfo))
					}
				
				});
			},
			GetCartInfo()
			{
				this.$scUtil.axiosPost(this, 'ShoppingCartApi/GetCartCount', {
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.shoppingcount=res.data.count;
					}
				
				});
			},
			GetMessageInfo()
			{
				this.$scUtil.axiosPost(this, 'MessageApi/GetMessageList', {
					userName: localStorage.getItem('username'),
					type:0
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.messageInfo=res.data;
					}
				
				});
			},
			search() {
				if(this.selectCate==0)
				{
					if(this.$route.path.indexOf('/category')!=-1)
					{
						let searchid=this.$route.query.id;
						if(searchid!=undefined){
							this.$router.push({ path:'/category' , query:{id:searchid,keywords:this.keywords}});
						}else{
							this.$router.push({ path:'/category' , query:{keywords:this.keywords}});
						}
					}else
					{
						this.$router.push({ path:'/category' , query:{keywords:this.keywords}});
					}
				}
				else
				{
					let searchid=this.selectCate;
					if(searchid!=undefined){
						this.$router.push({ path:'/category' , query:{id:searchid,keywords:this.keywords,selectText:this.cateName}});
					}else{
						this.$router.push({ path:'/category' , query:{keywords:this.keywords,selectText:this.cateName}});
					}				
				}
				
				//
			}
			,showPannel(){
				this.isPannelShow = true
			},
			hidePannel(){
				this.isPannelShow = false
			},
			showTopPannle(){
				this.isShowGuide = false;
				this.isTopPannelshow = true;
				this.isShowInfo = false;
				this.isShowOrder = false;
				this.isShowLanguage = false
			},
			hideTopPannle(){
				this.isTopPannelshow = false
			},
			showGuide(){
				this.isShowGuide = true;
				this.isTopPannelshow = false;
				this.isShowInfo = false;
				this.isShowOrder = false;
				this.isShowLanguage = false
			},
			hideGuide(){
				this.isShowGuide = false
			},
			showOrder(){
				this.isShowGuide = false;
				this.isShowInfo = false,
				this.isTopPannelshow = false;
				this.isShowOrder = true;
				this.isShowLanguage = false
			},
			hideOrder(){
				this.isShowOrder = false
			},
			infoShow(){
				this.isShowInfo = true,
				this.isShowGuide = false;
				this.isTopPannelshow = false;
				this.isShowOrder = false;
					this.isShowLanguage = false
			},
			hideInfo(){
				this.isShowInfo = false
			},
			showLanguage(){
				this.isShowGuide = false;
				this.isTopPannelshow =false ;
				this.isShowInfo = false,
				this.isShowOrder = false
				this.isShowLanguage = true
			},
			hideLanguage(){
						this.isShowLanguage = false
			},
			switchLanguage(lang) {
				console.log('Before language is:', this.$i18n.locale);
				console.log('Switching language to:', lang);
				console.log('After language is:', this.$i18n.locale);
				this.$i18n.locale = lang;
				localStorage.setItem('locale-lang', lang);
				this.hideLanguage();
				this.$router.go(0);
			}
		}
	}
</script>

<style scoped>
	a {
	    text-decoration: none;
	    color: #fff;
	}
	.head{
			background: #1d1d1f;
			height: 156px;
			width: 100%;
			display: flex;
			background-image: url(../assets/images/headBg2.png);
			flex-direction: column;
			align-items: center;
			justify-content: center;
			z-index: 999;
		}
	
		.headInner{
			width: 1200px;
		}
	
		.headTop{
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 12px;
		}
	
		.headTopLeft{
			color: #fff;
			display: flex;
			font-size: 13px;
			align-items: center;
		}
	
		.setTextPadding{
			margin-right: 10px;
		}
	
		.linkText{
			text-decoration: underline;
			text-underline-offset: 5px;
			text-decoration-color: #838384;
			color: #fff;
			cursor: pointer;
			margin: 0 10px;
		}
	
		.line1{
			width: 1px;
			height: 15px;
			background-color: #838384;
		}
	
		.headTopRight{
			display: flex;
			align-items: center;
			color: #fff;
		}
	
		.headTopRightLi,.headTopLiInner{
			display: flex;
			align-items: center;
		}
	
		.headTopRightLi{
			position: relative;
		}
	
	
		.headTopLiInner{
			font-size: 13px;
		}
	
		.headLiIcon{
			margin-right:10px;
		}
	
		.heatTran{
			margin: 0 17px 0 11px;
		}
	
		.headTel{
			font-size: 13px;
			color: #0380fe;
		}
	
	    .headTitle{
			font-size: 14px;
			color: #fff;
			width: 150px;
		}
	
		.line{
			width: 1px;
			height: 35px;
			background-color: #838384;
			margin: 0 25px;
		}
	
		.headMiddle{
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			width: 1200px;
			margin-top: 30px;
		}
	
/* 		.log{
			width: 155px;
			height: 44px;
		} */
	
		.searchLeft{
			width: 129px;
			height: 40px;
			background-color: #e2e2e2;
			border-top-left-radius: 5px;
			border-bottom-left-radius: 5px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			position: relative;
		}
	
		.downBlack{
			margin-left: 10px;
		}
	
		.searchMiddle{
			background-color: #ffffff;
			height: 40px;
			width:488px;
			display: flex;
			align-items: center;
			padding: 0 22px;
			box-sizing: border-box;
		}
	
		.searchAreaTop{
			display: flex;
			align-items: center;
		}
	
		.searchGray{
			margin-right: 10px;
		}
	
		.searchInput{
			font-size: 13px;
			color: #999999;
			border: none;
		}
	
		.searchInput:focus{
			outline: none;
		}
	
		.searchBtn{
			width: 64px;
			height: 40px;
			background-color: #0380fe;
			border-top-right-radius:5px;
			border-bottom-right-radius: 5px;
			color: #fff;
			font-size: 13px;
			color: #fff;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	
		.headUl{
			display: flex;
			align-items: center;
			color: #fff;
			font-size: 12px;
			height: 50px;
		}
	
		.headUl li{
			list-style: none;
			margin-right: 25px
		}
	
		.headCar{
			width: 155px;
			height: 40px;
			background-color: #0380fe;
			border-radius: 5px;
			color: #fff;
			font-size: 13px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 20px;
		}
	
		.carSmall{
			margin-right: 12px;
		}
	
		.headNum{
			margin-left: 10px;
			padding: 0px 5px;
			border-radius: 50px;
			background-color: #fff;
			color: #0380fe;
		}
	
		.pannel{
			width: 130px;
			background: #e2e2e2;
			border-radius: 5px;
			position: absolute;
			left: 0;
			top: 40px;
		}
	
		.pannel .li{
			height: 40px;
			width: 130px;
			font-size: 12px;
			color: #000;
			cursor: pointer;
			text-align: center;
			line-height: 40px;
			z-index: 9999;
		}
	
		.pannel .li:hover,
		.pannel .li.active{
				color: #0380fe;
				background: #fff;
		}
	
		.pannel .li:nth-child(1):hover,
		.pannel .li:nth-child(1).active{
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}
	
		.pannel .li:nth-last-child(1):hover,
		.pannel .li:nth-last-child(1).active{
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	
	
		.topPannel{
			position: absolute;
			top: 30px;
			left: 0;
			width: 256px;
			padding: 10px;
			box-sizing: border-box;
			background: #fff;
			border-radius: 5px;
			border-top-left-radius: 0px;
		}
	
		.topBg{
			background: #fff;
			border-radius: 5px;
			border-bottom-left-radius: 0px;
			color:  #000;
			margin-right: 10px;
			border-bottom-right-radius: 0px;
			height: 30px;
			padding: 0 10px;
			box-sizing: border-box;
		}
	
		.listTitle{
			font-size: 13px;
			color: #000;
			margin-bottom: 5px;
		}
	
		.listText{
			font-size: 12px;
			color: #333333;
			width: 70px;
			text-align: left;
			line-height: 30px;
			list-style: none;
		}
	
		.pannelList{
			margin-bottom: 10px;
			border-bottom: 1px dotted #f3f3f3;
			padding-bottom: 10px;
		}
	
		.pannelList:nth-last-child(1){
			border-bottom: 0px solid #f3f3f3;
			margin-bottom: 0;
			padding-bottom: 0;
		}
	
		.topPannelUl{
			display: flex;
			flex-wrap: wrap;
		}
	
		.tranTop{
			transform: rotate(180deg);
		}
	
		.guideArea{
			position: absolute;
			top: 30px;
			left: 0;
			width:130px;
			box-sizing: border-box;
			background: #fff;
			border-radius: 5px;
			border-top-left-radius: 0px;
			border-top-right-radius: 0px;
		}
		
		.languageArea{
			position: absolute;
			top: 30px;
			left: 0;
			width:93.5%;
			box-sizing: border-box;
			background: #fff;
			border-radius: 5px;
			border-top-left-radius: 0px;
			border-top-right-radius: 0px;
		}
	
		.languageArea ul li{
			list-style: none;
			text-align: center;
			width: 100%;
			cursor: pointer;
		}
	
		.languageArea ul li:hover{
			background: #e2e2e2;
		}
		
		
		.guideArea ul li{
			list-style: none;
			text-align: center;
			width: 100%;
			cursor: pointer;
		}
			
		.guideArea ul li:hover{
			background: #e2e2e2;
		}
			
	
		.orderArea{
			width: 132px;
		}
	
		.infoArea{
			width: 318px;
			height: 306px;
			background: #fff;
			border-radius: 10px;
			position: absolute;
			top: 30px;
			left: -100px;
			box-sizing: border-box;
		}
	
		.infoAreaTitle{
			color: #000;
			padding: 10px;
			font-size: 12px;
			box-sizing: border-box;
		}
	
		.emptyArea{
			widows: 318px;
			height: 240px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			color: #000;
		}
		.infos{
			widows: 318px;
			height: 240px;
			display: flex;
			flex-direction: column;
			overflow-y: auto;
		}
	
		.emptyText{
			margin-top: 10px;
		}
	
		.lookMore{
			width: 100%;
			height: 39px;
			background: #e2e2e2;
			color: #000;
			font-size: 12px;
			text-align: center;
			line-height: 39px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
	}
	
	.infoLi{
		padding: 10px 20px;
	}
	
	.infoLi:hover{
		background: #f6f6f6;
	}
	
	.infoTitle{
		display: 100%;
		display: flex;
		justify-content: space-between;
		font-size: 12px;
		color: #000;
	}
	
	.time{
		font-size: 10px;
		color: #666666;
	}
	
	.infoText{
		font-size: 10px;
		color: #888888;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin-top: 5px;
	}
</style>
